export const DATE_FORMATS = {
  DATE: 'date',
  DATE_IN_CURRENT_YEAR: 'date_in_curr_year',
  DATE_RANGE: 'date_range',
  DATE_IN_CHART: 'date_in_chart',
  MEETING_DATE_TIME_IN_CURRENT_YEAR: 'meeting_date_time_in_curr_year',
  MEETING_DATE_NOT_IN_CURRENT_YEAR: 'meeting_date_not_in_curr_year',
  TIME: 'time',
  TIME_RANGE: 'time_range',
  MONTH_DAY_IN_CAL: 'month_day_in_cal',
  MONTH_YEAR_IN_CAL: 'month_year_in_cal',
  DATE_TIME_WITH_SECONDS: 'date_time_with_seconds',
  DAY_MONTH_DATE: 'day_month_date',
};
